import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Form from "./pages/Form";
import Preview from "./pages/Preview";
import Result from "./pages/Result";
import Applicant from "./pages/Applicant";
import Complete from "./pages/Complete";
import Home from "./pages/Home";
import Statistics from "./pages/Statistics";
import ResultUser from "./pages/ResultUser";
import Refund from "./pages/Refund";

const App = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/form/:programId" element={<Form />} />
      <Route path="/form/preview" element={<Preview />} />
      <Route path="/form/apply/:programIdOrCustomUrl" element={<Applicant />} />
      <Route path="/form/complete/:programIdOrCustomUrl" element={<Complete />} />
      <Route path="/form/:programId/result/:formAnswerId" element={<Result />} />
      <Route path="/form/:programId/result-user/:formAnswerId" element={<ResultUser />} />
      <Route path="/form/:programId/statistics" element={<Statistics />} />
      <Route path="/form/refund" element={<Refund />} />
    </Routes>
  </BrowserRouter>
);

export default App;
